import { ImportModule } from "app/helpers/importsHelper";
import { ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import ENV from "../../../../../config";
import MobileRoutes from "../../helpers/MobileRouteHelper/MobileRouteHelper";
import MobileRoute from "../MobileRoute/MobileRoute";
import MobileRouterRedirects from "./components/MobileRouterRedirects/MobileRouterRedirects";

const MobileRouter = () => {
  const location = useLocation();

  return (
    <Switch>
      <Route
        path="/:url*"
        exact
        strict
        render={props => <Redirect to={`${location.pathname}/`} />}
      />
      {!SessionHelper.isAuthenticated() && ENV.CSS_THEME === "DEFAULT" && (
        <Route exact path={ROUTES.root} component={ImportModule.PublicScreen} />
      )}
      {!SessionHelper.isAuthenticated() && (
        <Route
          path={ROUTES.register}
          component={ImportModule.RedirectToLogin}
        />
      )}
      {!SessionHelper.isAuthenticated() && (
        <Route exact path={ROUTES.login} component={ImportModule.AuthScreen} />
      )}
      {SessionHelper.isAuthenticated() &&
        MobileRoutes.map((route, index) => (
          <MobileRoute
            exact={route.exact}
            key={index}
            path={route.path}
            component={route.component}
          />
        ))}
      <MobileRouterRedirects />
    </Switch>
  );
};

export default MobileRouter;
